import Translation from '@/client/components/Translation';
import classNames from '@/external/classNames';

type Props = {
  position?: number;
  username?: string;
  isMyScore?: boolean;
  translations: Record<string, string>;
};

const Username: React.FC<Props> = ({
  username,
  position,
  isMyScore,
  translations,
}) => (
  <>
    <span
      className={classNames(
        'm-0 place-self-center justify-self-start text-moon-12 text-bulma',
        isMyScore && 'font-medium',
      )}
    >
      {username && username}
      {!username && (
        <>
          {position}{' '}
          <Translation
            translations={translations}
            id="game-leaderboard.position"
          />
        </>
      )}
    </span>
  </>
);

export default Username;
